// import { Dropdown } from "@trussworks/react-uswds";
import { Dispatch, SetStateAction, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
    SearchFilters
  } from "../../types/v1_schemas";
import TypeOfHelpInput from "../Search/Filters/TypeOfHelpInput";

const DropdownToggle = styled(Dropdown.Toggle as any)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  background-color: white;
  color: var(--dark_blue);
  height: 50px;
  border-width: 1px;
  border-radius: 0.25rem;
  border-color: #1A103F;
  width: 350px;
  @media (max-width: 700px) {
    width: 100%;
  }
  
  &:hover {
    border: none;
    background: var(--dark_green) !important;
    color: white !important;
  };
  &:focus {
    border: none;
    background: var(--dark_green) !important;
    color: white !important;
  };
  &.active {
    border: none;
    background: var(--dark_green) !important;
    color: white !important;
  };
  &.btn.show {
    border: none;
    background: var(--dark_green) !important;
    color: white !important;
  };
  &:show {
    border: none;
    background: var(--dark_green) !important;
    color: white !important;
  };

`;

const DropdownMenu = styled(Dropdown.Menu as any)`
  width: 350px;
  @media (max-width: 700px) {
    width: 100%;
  }
`;

const DropdownElement = styled(Dropdown as any)`
`;

export type ResponseServiceProvided = {
  id: string;
  categoryId: number;
  plainLanguage: string;
  text: string;
};

function TypeOfHelpDropDown({
  filters,
  setFilters,
}: {
  filters: SearchFilters;
  setFilters: Dispatch<SetStateAction<SearchFilters>>;
}) {
  const { t } = useTranslation();
  const [selectedServices, setSelectedServices] = useState<String[]>([]);

  return (
    <DropdownElement
      id="type-of-help-dropdown"
      defaultValue=""
      aria-label={t("dropdownPrompt")}
    >
 
      <DropdownToggle
        className={!!filters.serviceProvidedIds?.length ? "text-black text-wrap" : "text-base text-wrap"}
      >
 
          {selectedServices.length > 0 ? selectedServices.length > 1 ? t("multipleServicesSelected") : selectedServices.join(", ") : t("dropdownPrompt")}
      </DropdownToggle>
      <DropdownMenu>
        <div className="padding-2">
          <TypeOfHelpInput
            legend={""}
            isMobile={false}
            filters={filters}
            setFilters={setFilters}
            selectedServices={selectedServices}
            setSelectedServices={setSelectedServices}
          />
        </div>
      </DropdownMenu>
    </DropdownElement>
  );
}

export default TypeOfHelpDropDown;
